import * as types from "../actions/ActionTypes";
import { authUserInitial } from "../store/InitialStore";

export default function AuthUserDetailsReducer(
  state = authUserInitial,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case types.AUTH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...payload,
        error: false,
      };

    default:
      return state;
  }
}
